import type { ReactNode } from "react";

export function EstadoVacio({
  titulo,
  descripcion,
  accion,
}: {
  titulo: string;
  descripcion?: string;
  accion?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-borde px-6 py-16 text-center">
      <p className="text-sm font-semibold text-texto">{titulo}</p>
      {descripcion && <p className="mt-1 max-w-sm text-sm text-texto-secundario">{descripcion}</p>}
      {accion && <div className="mt-4">{accion}</div>}
    </div>
  );
}
